module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "note"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/pppbookdeal0005#toc"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("While I love South Florida just as it really and truly is, this is a work of fiction, and I have taken occasional liberties with the landscape and place-names involved. May they please the innocent and guilty alike.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc9df920","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ppp-bookdeal0009.vue
// module id = 81
// module chunks = 0